import React from 'react';
import { Check } from 'lucide-react';

export function SuccessMessage() {
  return (
    <div className="text-center p-8 bg-white rounded-xl shadow-sm">
      <div className="inline-flex items-center justify-center w-16 h-16 bg-green-100 rounded-full mb-4">
        <Check className="w-8 h-8 text-green-500" />
      </div>
      <h3 className="text-2xl font-semibold text-gray-900 mb-2">Thank You for Joining!</h3>
      <p className="text-gray-600">
        We'll keep you updated about our launch and early access opportunities.
      </p>
    </div>
  );
}